import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";

import Header from "../../UI/Header";
import promoImage from "./images/connect-services-promo.jpg";
import { useTheme } from "../../../reducers/layoutReducer/selectors";

const LEARN_MORE_URL =
  "https://our.place.com/spaces/1/operators/articles/business-ops/13359/transactly-connect-services";
const BRIVITY_LEARN_MORE_URL =
  "https://www.brivityknowledge.com/docs/connect-services-your-client-s-move-in-partner";

interface ConnectServicesPromoProps {
  onGetStarted?: () => void;
}

const ConnectServicesPromo = ({ onGetStarted = () => {} }: ConnectServicesPromoProps) => {
  const theme = useTheme() as { name?: string } | null;
  const learnMoreUrl = theme?.name === "brivity-theme" ? BRIVITY_LEARN_MORE_URL : LEARN_MORE_URL;

  return (
    <div className="tw-flex tw-flex-col tw-gap-[16px]">
      <Header header="Connect Services" />

      <div className="tw-flex tw-flex-col tw-gap-[12px] tw-rounded-[4px] tw-border tw-border-solid tw-border-gray-10 tw-bg-white tw-px-[16px] tw-py-[14px] tw-shadow-card">
        <div className="tw-text-14d tw-text-gray-75">
          <div className="tw-font-semibold">Get Connect Services</div>
          <div className="tw-font-normal">
            Your white-glove support for buyers and tenants connecting utilities and services for their new
            home.
          </div>
        </div>

        <img
          src={promoImage}
          alt="Couple relaxing in their new home among moving boxes"
          className="tw-block tw-h-[100px] tw-w-full tw-rounded-[12px] tw-object-cover"
        />

        <div className="tw-flex tw-items-center tw-justify-between">
          {/* @ts-expect-error props */}
          <TextButton size="small" onClick={() => window.open(learnMoreUrl, "_blank")}>
            Learn More
          </TextButton>
          {/* @ts-expect-error props */}
          <Button size="small" schema="secondary" onClick={onGetStarted}>
            Get Started
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConnectServicesPromo;
